import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { type ComponentPropsWithoutRef, type ElementRef, forwardRef } from 'react';
import { cn } from '../lib/utils.js';

export const Checkbox = forwardRef<
  ElementRef<typeof RadixCheckbox.Root>,
  ComponentPropsWithoutRef<typeof RadixCheckbox.Root>
>(({ className, ...props }, ref) => (
  <RadixCheckbox.Root
    ref={ref}
    className={cn(
      'peer relative size-[18px] shrink-0 rounded-full border border-border bg-card hover:bg-accent/15 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground',
      className,
    )}
    {...props}
  >
    {/* Indicator ocupa 100% do root (absolute inset-0) para centralizar de
       forma robusta, independente de line-height/baseline do container pai
       (call sites usam mt-0.5, items-start, etc.). Usamos um DOT preenchido
       (não o ícone de check): num círculo de 18px o dot de 8px centraliza
       perfeitamente e tem proporção estável (radio-like), sem o desalinhamento
       óptico do glyph de check. `bg-current` herda a cor do texto
       (primary-foreground quando marcado). */}
    <RadixCheckbox.Indicator className="absolute inset-0 flex items-center justify-center">
      <span className="size-2 shrink-0 rounded-full bg-current" aria-hidden="true" />
    </RadixCheckbox.Indicator>
  </RadixCheckbox.Root>
));

Checkbox.displayName = 'Checkbox';
